import { Consent } from '../../../interfaces/Consent';
import { Consents } from '../../../interfaces/Consents';
import { ConsentDto } from '../../../interfaces/dtos/ConsentDto';

export default function transformConsent(dto: ConsentDto): Consent {
  const data: Consents[] = [];

  dto?.consents?.sort((a, b) => a.consentId - b.consentId).forEach((c) => {
    data.push({
      consentId: c.consentId,
      purposeId: c.purposeId,
      description: c.description,
      value: c.value,
    });
  });
  return { uci: dto?.uci, consents: data };
}
